import React, { useState } from 'react';
import {
  Chip,
  Menu,
  MenuItem,
  ListItemText,
} from '@mui/material';
import { getStatusColor } from '../../utils/helper/tablehelper';


const ClickableChip = ({ 
  status, 
  onStatusChange, 
  disabled = false,
  allowUpdate = true,  // New variable to control update functionality
  size = 'small',
  statusOptions,  // Now passed as prop instead of hardcoded
  ...chipProps 
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });

  const handleChipClick = (event) => {
    if (disabled || !allowUpdate) return;
      
    event.preventDefault();
    event.stopPropagation();
    
    const rect = event.currentTarget.getBoundingClientRect();
    setMenuPosition({
      top: rect.bottom,
      left: rect.left
    });
    
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleStatusChange = (newStatus) => {
    if (onStatusChange) {
      onStatusChange(newStatus);
    }
    handleMenuClose();
  };

  const statusInfo = getStatusColor(status);

  return (
    <>
      <Chip
        label={statusInfo.label}
        color={statusInfo.color}
        size={size}

        sx={{ 
          fontWeight: 500,
          cursor: (disabled || !allowUpdate) ? 'default' : 'pointer',
          '&:hover': (disabled || !allowUpdate) ? {} : {
            opacity: 0.8,
            transform: 'scale(1.05)'
          }
        }}
        onClick={handleChipClick}
        {...chipProps}
      />
      
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorReference="anchorPosition"
        anchorPosition={menuPosition}
        PaperProps={{
          sx: {
            minWidth: 200,
            maxHeight: 300,
          }
        }}
      >
        {
        statusOptions?.map((option) => (
          <MenuItem
            key={option.value}
            onClick={() => handleStatusChange(option.value)}
            selected={option.value === status}
          >
            <ListItemText primary={option?.label} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ClickableChip;
